import { createI18nText } from '@hilma/netina2all';

const payment = createI18nText({
	he: {
		ohNo: 'אוי לא!',
		dem: 'שגיאה בתשלום, נסו שוב',
		ta: 'נסה שוב',
		popup: {
			title: 'התשלום בוטל בהצלחה',
			text: 'ניתן לערוך את פרטי הרכישה בלחיצה על הכפתור',
			btn: 'חזרה לרכישה'
		},
		loginError: 'העסקה אושרה אבל הייתה תקלה בהתחברות לאזור האישי. נסה שוב מאוחר יותר',
		bp: {
			title: 'הזמנתך התקבלה בהצלחה!',
			titleStart: 'הזמנתך',
			titleEnd: 'התקבלה בהצלחה!',
			orderNumber: 'מספר הזמנה',
			sTitle: 'באזור האישי ניתן:',
			page: 'לראות את פרטי ההזמנה והקבלות',
			pen: 'לבצע שינויים',
			station: 'לראות את פרטי תחנת החלוקה',
			button: 'לאזור אישי',
			share: 'שתף ב-'
		},
		loggingIn: 'העסקה אושרה. מתחבר לאזור האישי',
	},

	en: {
		ohNo: 'Oh no!',
		dem: 'Error paying, please try again',
		ta: 'Try again',
		popup: {
			title: 'Payment successfully canceled',
			text: 'You can edit the purchase details by clicking the button',
			btn: 'Back to purchase'
		},
		loginError: 'The transaction was approved but there was an error logging into your profile. Try again later',
		bp: {
			title: 'Your order has been successfully received!',
			titleStart: 'Your order',
			titleEnd: 'has been successfully received!',
			orderNumber: 'Order number',
			sTitle: 'In your profile you can:',
			page: "See your order's details and receipts",
			pen: 'Make changes',
			station: 'See the details of the distribution station',
			button: 'To your profile',
			share: 'Share on'
		},
		loggingIn: 'The transaction was approved. Connecting to your profile',
	}
});

export default payment;